<template>
	<Col>
		<NavigationAccordionHeader
			:to="to"
			:title="title"
			:settings="settings"
			:sections="sections"
			:isOpen.sync="isOpen"
			:createNewConfig="createNewConfig"
			:additionalItemSuffix="additionalItemSuffix"
			:titleSuffixComponent="titleSuffixComponent"
			:collapsedModeNavButtonItem="collapsedModeNavButtonItem"
		/>
		<v-expand-transition v-if="!useIsSidebarCollapsed">
			<NavigationAccordionContent
				:to="to"
				v-if="isOpen"
				:settings="settings"
				:sections="sections"
				:additionalItemSuffix="additionalItemSuffix"
			/>
		</v-expand-transition>
	</Col>
</template>
<script>
import { mapGettersShorthand } from '@/store/utils/mappers';
import NavigationAccordionHeader from './NavigationAccordionHeader';
import NavigationAccordionContent from './NavigationAccordionContent';
import { useIsSidebarCollapsed } from '@/store/modules/appLayout/getters';
export default {
	name: 'NavigationAccordion',
	props: {
		to: { type: Function },
		title: { type: String },
		sections: { type: Array },
		settings: { type: Object },
		createNewConfig: { type: Object },
		additionalItemSuffix: { type: Object },
		titleSuffixComponent: { type: Object },
		collapsedModeNavButtonItem: { type: Object },
	},
	components: { NavigationAccordionContent, NavigationAccordionHeader },
	computed: { ...mapGettersShorthand({ useIsSidebarCollapsed }) },
	data() {
		return { isOpen: true };
	},
};
</script>
